import React from 'react'
import './Booking.sass'
import { Helmet } from 'react-helmet'

function Booking() {
  return (
    <div id="booking" className="Booking">
      <Helmet>
        <title>
          Бронирование номеров в Хостеле "Заполярье", г. Мурманск - официальный
          сайт.
        </title>
        <meta
          name="description"
          content="Забронируйте комфортный номер для удобного проживания в самом центре г. Мурманск"
        />
      </Helmet>
      <div className="DefaultContainer">
        <div id="tl-booking-form"></div>
      </div>
    </div>
  )
}

export default Booking
